import React from "react";
import { Box, Typography, List } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Icon from "../components/NGMaterialIcon/NGMaterialIcon";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { useOidc } from "../library/auth";
import { isNative } from "../library/native";
import AppError from "../library/appError";
import { log } from "../library/logger";

const tag = "ErrorElement";

const ErrorElement: React.FC = () => {
  const error = useRouteError();
  const oidc = useOidc();
  const theme = useTheme();
  log.error(tag, "Error", error);

  if (isRouteErrorResponse(error)) {
    if (error.status === 401) {
      if (isNative()) {
        window.location.href = "/local/login";
      } else if (oidc != null) {
        oidc.logout({ redirectTo: "current page" });
      }
      return <></>;
    }

    return (
      <div>
        <h2>{error.status}</h2>
        <div>{error.data.Message}</div>
      </div>
    );
  }

  if (error instanceof AppError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        width="100%"
        height="100%"
        textAlign="center"
        gap={2}
      >
        <Icon name="lock" style={{ color: theme.palette.error.main, fontSize: 64 }} />
        <Typography variant="h4" color="error" gutterBottom>
          {error.status} – Unauthorized
        </Typography>
        <Typography variant="body1">You do not have permission to view this page.</Typography>
        <List>
          {error.reasons &&
            error.reasons.length > 0 &&
            error.reasons.map((reason, index) => (
              <Typography variant="body1" key={index}>
                {reason.message} {reason.property ? `(${reason.property})` : ""}
                {index < error.reasons.length - 1 ? ", " : ""}
              </Typography>
            ))}
        </List>
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      textAlign="center"
      gap={2}
    >
      <Icon name="lock" style={{ color: theme.palette.error.main, fontSize: 64 }} />
      <Typography variant="h4" color="error" gutterBottom>
        401 – Unauthorized
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        You do not have permission to view this page
      </Typography>
    </Box>
  );
};

export default ErrorElement;
